import { Responsive, UIHeading3, UIHeading4 } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './MarkBlock.css';

export enum EMarkBlockType {
  POSITIVE = 'Плюсы:',
  NEGATIVE = 'Минусы:',
}

interface IMarkBlockProps {
  type: EMarkBlockType;
  children: string;
  textClassName?: string;
}

export const MarkBlock = (props: IMarkBlockProps) => {
  return (
    <div className={styles['mark-block']}>
      <Responsive phone tablet>
        <UIHeading4>{props.type}</UIHeading4>
      </Responsive>
      <Responsive desktop>
        <UIHeading3>{props.type}</UIHeading3>
      </Responsive>

      <p className={cn(styles['text'], props.textClassName)}>{props.children}</p>
    </div>
  );
};
